import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { Button, Dropdown } from "react-bootstrap";
import { request } from "../../../utils/api";
import Loading from "../utilComponent/Loading";
import Pagination from "../utilComponent/Pagination";
import { showImage } from "../../../utils";

const AssignProductList = () => {
  const navigate = useNavigate();
  const { date } = useParams();

  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);

  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 15,
    total: 0,
    last_page: 1,
  });

  const transformData = (items = []) => {
    return items
      .filter((item) => item.assigned_products?.length > 0)
      .flatMap((item) => {
        const { user, assigned_products } = item;

        return assigned_products.map((product) => ({
          id: product.id,
          product_id: product.id,
          product_name: product.name,
          product_qty: product.quantity,
          product_price: product.price,
          product_image: product.images[0]?.url,
          sku: product.sku,
          warehouse_name: product.warehouse?.name || "N/A",
          user_name: user.name,
          user_email: user.email,
          user_id:user.id
        }));
      });
  };

  const getAssignProductList = async (page = 1) => {
    try {
      setLoading(true);

      const response = await request({
        url: `assign-products?page=${page}&per_page=${pagination.per_page}&to_date=${date}`,
        method: "GET",
      });

      if (response.status && response.data) {
        setProducts(transformData(response.data.items));
        setPagination(response.data.pagination);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAssignProductList(pagination.current_page);
  }, []);

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, current_page: page }));
    getAssignProductList(page);
  };

  const filteredProducts = products.filter((item) =>
    Object.values(item).some((v) =>
      String(v).toLowerCase().includes(searchText.toLowerCase())
    )
  );

  return (
    <div>
      <div className="page-toolbar px-xl-4 px-sm-2 px-0 py-3">
        <div className="container-fluid">
          <ol className="breadcrumb bg-transparent mb-0">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item">Assign Product</li>
            <li className="breadcrumb-item active">Assign Product List</li>
          </ol>
        </div>
      </div>

      <div className="container-fluid mt-3">
        <div className="card shadow-sm">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h6 className="card-title m-0">Assign Product List</h6>
            <Button variant="primary" onClick={() => navigate("/assign-product")}>
              Back
            </Button>
          </div>

          <div className="card-body">
            <div className="row mb-3">
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search assign product..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
            </div>
            {loading ? (
              <Loading />
            ) : (
              <div className="row">
                {filteredProducts.length ? (
                  filteredProducts.map((item) => (
                    <div key={item.id} className="col-xl-4 col-lg-6 mb-4">
                      <div className="card h-100 shadow-sm">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-start">
                            <div className="d-flex">
                              <img
                                src={showImage(item.product_image)}
                                alt={item.product_name}
                                width={60}
                                height={60}
                                className="me-3 rounded"
                                style={{ objectFit: "cover" }}
                              />

                              <div>
                                <h6 className="fw-bold mb-1">
                                  {item.product_name}
                                </h6>
                                <p className="mb-0 text-muted">
                                  SKU: {item.sku}
                                </p>
                              </div>
                            </div>

                            <Dropdown align="end">
                              <Dropdown.Toggle
                                variant="light"
                                className="border-0 p-0"
                              >
                                <FaEdit />
                              </Dropdown.Toggle>

                              <Dropdown.Menu>
                                <Dropdown.Item
                                  onClick={() =>
                                    navigate(
                                      `/assign-product/${item.user_id}`
                                    )
                                  }
                                >
                                  Edit Assign
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>

                          <hr />

                          <p className="mb-1">
                            📦 Qty: <strong>{item.product_qty}</strong>
                          </p>

                          <p className="mb-1">
                            💰 Price:{" "}
                            <strong>{item.product_price}</strong>
                          </p>

                          <p className="mb-1">
                            🏬 Warehouse:{" "}
                            <strong>{item.warehouse_name}</strong>
                          </p>

                          <p className="mb-0">
                            👤 User: <strong>{item.user_name}</strong>
                            <br />
                            📧 {item.user_email}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-5">
                    {searchText
                      ? "No matching assign product found"
                      : "No assign product available"}
                  </div>
                )}
              </div>
            )}
            {pagination.last_page > 1 && (
              <Pagination
                currentPage={pagination.current_page}
                lastPage={pagination.last_page}
                onPageChange={handlePageChange}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignProductList;
